import {AUTHSUCCESS, AUTHFAILED} from '../constants'
import axiosInstance from "../utils/axios.interceptor";

/***
 * Authenticates user
 */
export const authenticateUser = (login,password) => {
  return async (dispatch) => {
    let response = await axiosInstance({
      method: 'POST',
      url: '/authenticateuser',
      data: {"login": login, "password": password}
    });
    //This is to trigger componentWillReceiveProps()
    response.data.timestamp = new Date().toLocaleString();

    if(response.data.success){
      dispatch({type:AUTHSUCCESS,payload:response.data});
    }else{
      dispatch({type:AUTHFAILED,payload:response.data});
    }
  };
};
